import { ModalDialog, ModalService } from './modal.service';
import { ChangeDetectorRef, Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { DialogComponent as SyncfusionDialogComponent, DialogModule } from '@syncfusion/ej2-angular-popups';
import { BeforeCloseEventArgs } from '@syncfusion/ej2-popups';
import { TranslatePipe } from '@ngx-translate/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DialogModule, NgClass, TranslatePipe]
})
export class ModalComponent implements OnInit{

  @ViewChild('dialog') dialog: SyncfusionDialogComponent | null = null;

  public modalDialog: ModalDialog | null = null;

  constructor(public modalService: ModalService, private cdr: ChangeDetectorRef) { }

  public ngOnInit(): void {
    this.modalService.dialogSubject.subscribe((modalDialog) => {
      const actualDialog = this.modalDialog;
      this.modalDialog = modalDialog;
      if (!modalDialog) {
        this.modalDialog = null;
        this.hideDialog();
      } else {
        this.modalDialog = modalDialog;
        this.showDialog();
        if (actualDialog) {
          this.cdr.detectChanges();
        }
      }
    });
  }

  public okClicked(): void {
    this.hideDialog();
    this.modalDialog?.onOkSubject.next(null);
  }

  public cancelClicked(): void {
    this.hideDialog();
    this.modalDialog?.onCancelSubject.next(null);
  }

  public onClose(eventArgs: BeforeCloseEventArgs): void {
    if (eventArgs.isInteracted) {
      this.modalDialog?.onCancelSubject.next(null);
    }
  }

  private hideDialog(): void {
    this.dialog?.hide();
    if (this.dialog) {
      this.dialog.zIndex = 1000;
    }
  }

  private showDialog(): void {
    if (this.dialog) {
      this.dialog.zIndex = 200000;
      this.dialog.show();
    }
  }
}
